import { useEffect } from "react";
import Fade from "@mui/material/Fade";
import { Theme } from "../../data/style/Theme";
import { useQuery } from "@tanstack/react-query";
import { getUserActivity } from "../../api/user";
import { useAuth } from "../../context/AuthContext";
import { SpacedRow, AllCenteredColumn } from "../../data/style/Style";

const ActivityLabel = ({ title, type, setCompletion }) => {
  const { user } = useAuth();

  const { data, isPending } = useQuery({
    queryKey: ["user", user.id, "activity", type],
    queryFn: ({ signal }) => getUserActivity({ type, signal }),
  });

  useEffect(() => {
    if (!isPending && data.exists) {
      setCompletion((prev) => prev + 20);
    }
  }, [isPending]);

  return (
    <>
      {!isPending && (
        <Fade timeout={(type + 1) * 500} in={true}>
          <SpacedRow
            sx={{
              alignItems: "center",
              padding: "6px 8px",
              borderRadius: 10,
              background: data.exists
                ? "rgba(249,115,22,.05)"
                : Theme.palette.card,
              border: `1px solid ${data.exists ? "rgba(249,115,22,.18)" : Theme.palette.border}`,
            }}
          >
            <span
              style={{
                fontFamily: "DM Sans, sans-serif",
                fontSize: "0.8rem",
                color: data.exists
                  ? Theme.palette.textSub
                  : Theme.palette.muted,
              }}
            >
              {title}
            </span>
            <AllCenteredColumn
              sx={{
                width: 20,
                height: 20,
                borderRadius: "50%",
                background: data.exists ? Theme.palette.orange : "transparent",
                border: `2px solid ${data.exists ? Theme.palette.orange : Theme.palette.muted}`,
                fontSize: "0.9rem",
                color: "#fff",
              }}
            >
              {data.exists && "✓"}
            </AllCenteredColumn>
          </SpacedRow>
        </Fade>
      )}
    </>
  );
};

export default ActivityLabel;
